import { Component, OnInit } from '@angular/core';
import { NotesService} from '../../services/notes.service';
import { AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css']
})
export class NotesComponent implements OnInit {
  selectedNote: number = 0;
  selectedNoteID: number = 0;
  choosedColor: number = 0;

  firstEnd = 0;
  secondStart = 0;

  orderedNote = -1;

  newNote = { 
    settings: 0,
    fontSize: 0,
    noteText: ""
  };

  editedNote = {
    id: "",
    settings: 0,
    fontSize: 0,
    noteText: "",
    idUser: localStorage.getItem("idUser"),
    state: 0
  };

  constructor(private noteService: NotesService, private authService: AuthService) {}

  ngOnInit() {
    this.noteService.getNotes();
  }

  addNote(){
    if(this.noteService.addNote(this.newNote) == true){
      this.newNote.noteText = "";
    } 
  }

  editNote(i){
    this.editedNote.id = this.noteService.notes[i].id;
    this.editedNote.noteText = this.noteService.notes[i].noteText;
    this.editedNote.settings = this.noteService.notes[i].settings;
    this.editedNote.fontSize = this.noteService.notes[i].fontSize;

    this.selectedNote = i;

  }

  updateNote(){
    this.editedNote.settings = (10*this.editedNote.fontSize)+Number(this.editedNote.settings);
    this.noteService.updateNote(this.editedNote, this.selectedNote);
  }

  removeNote(i, id){
    this.noteService.removeNote(i, id);
    
  }
  
  dropSuccess(i){
    this.orderedNote = -1;
    this.noteService.changeOrder(i+1);
  }


  dragStart(i,isLeft){
    this.orderedNote = i;
    if(isLeft == true){
      this.noteService.firstEnd--;
    }
    else{
      this.noteService.secondStart++;
    }
    
   
  }

  dragEnd(){
    this.orderedNote = -1;
    this.noteService.getSeparator();
  }


  getSeparator(){
    let badNumberIndex = -1;
    let badNumberValue = -1;
    for(let i = 0; i < this.noteService.notes.length; i++){
      if(this.noteService.notes[i].noteText == ""){
        this.firstEnd = i;
        this.secondStart = i;
      }
      if(this.noteService.notes[i].orderNumber != (i+1) && badNumberIndex < 0){
        badNumberIndex = i;
      }
      if(this.noteService.notes[i].orderNumber != (i+1) && badNumberIndex >= 0){
        badNumberValue = i+1;
      }
    }
  
    if(badNumberIndex >= 0){
      this.noteService.doRightOrder(badNumberIndex,badNumberValue);
    }
  }

  orderUp(i){
    this.noteService.orderUp(i);
  }
  orderDown(i){
    this.noteService.orderDown(i);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/notes/notes.component.ts